import { Divider } from 'ui/divider';
import styled from 'styled-components';
import { NavTabsList, NavTabTrigger } from 'ui/tabsGroup';
import { Link } from 'ui/links';
import {
  Body2,
  borderRadius,
  colors,
  fontWeights,
  spacing,
  subtleShadow,
  Overline,
  subtitle1,
  caption,
  monochromeLink,
} from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const Wrapper = styled.div`
  ${borderRadius.xl};
  ${subtleShadow};
  background: ${colors.backgroundPrimary};
  border-radius: ${spacing.half};
  padding: ${spacing.plusHalf};
  margin-top: ${spacing.double};
  `;

export const PerformanceOverTimeContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${spacing.plusHalf};

  @media screen and (width <= 1200px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const PerformanceOverTimeMetricCards = styled.div`
  gap: ${spacing.plusQuarter};
  display: flex;
  padding: ${spacing.plusHalf};
  flex-direction: column;
  flex: 3;
  min-width: ${pxToRem(320)};
  border-radius: ${spacing.threeEights};
  background: ${colors.backgroundSecondary};
  justify-content: space-between;
`;

export const StyledNavTabsList = styled(NavTabsList)`
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  padding: 0;
  gap: 0;
  border: ${spacing.single} solid ${colors.borderPrimarySubtle};
  border-bottom: none;
  border-top-left-radius: ${borderRadius.lg};
  border-top-right-radius: ${borderRadius.lg};

  > button:first-of-type {
    border-top-left-radius: ${borderRadius.lg};

    &::before {
      border-top-left-radius: ${borderRadius.lg}; 
    }
  }

  > button:last-of-type {
    border-top-right-radius: ${borderRadius.lg};

    &::before {
      border-top-right-radius: ${borderRadius.lg}; 
    }
  }
`;

export const StyledNavTrigger = styled(NavTabTrigger)`
  all: unset;
  width:100%;
  align-items: center;
  border-radius: ${borderRadius.none};
  color: ${colors.secondaryText};
  cursor: pointer;
  circle,
  path,
  rect {
    fill: ${colors.iconPrimary};
  }
  display: flex;
  position: relative;
  justify-content: flex-start;
  padding: ${spacing.plusQuarter};
  background-color: ${colors.backgroundSecondary};
  
  &:nth-child(even) {
   border-left: ${spacing.single} solid ${colors.borderPrimarySubtle};
   border-right: ${spacing.single} solid ${colors.borderPrimarySubtle};
  
  }

  &[data-state='active'] {
    border-bottom: 1px solid ${colors.white};
    background-color: ${colors.backgroundPrimary};
    color: ${colors.textLink};
    circle,
    path,
    rect {
      fill: ${colors.borderInteractive};
    }
    &::before {
      bottom: 93%;
      border-radius: ${borderRadius.none};
      background-color: ${colors.borderInteractive};
      content: '';
      height: ${spacing.quarter};
      left: -${spacing.single};
      position: absolute;
      right: -${spacing.single};
      border-bottom: none;
    }

    p {
      font-weight: ${fontWeights.medium};
      color: ${colors.textPrimary};
    }
  }

  &:hover {
    background-color: ${colors.backgroundSecondary};
    color: ${colors.textPrimary};
    path,
    rect {
      fill: ${colors.textPrimary};
    }
    &[data-state='active'] {
      background-color: transparent;
    }
  }

  &[data-state='inactive'] {
    border-bottom: ${spacing.single} solid ${colors.borderPrimarySubtle};

    p {
      font-weight: ${fontWeights.regular};
      color: ${colors.textSecondary};
    }
  }
`;

export const StyledGraphContainer = styled.div`
 flex: 7;
`;

export const LinkNav = styled(Link)`
  align-items: center;
  display: inline-flex;
  border: none;
`;

export const ButtonText = styled(Body2)`
  font-weight: ${fontWeights.semiBold};
`;

export const PerformanceOverTimeTabContentWrapper = styled.div`
  border: ${spacing.single} solid ${colors.borderPrimarySubtle};
  border-top: none;
  padding: ${spacing.plusHalf};
  padding-bottom: 0;
  border-radius: 0 0 ${spacing.half} ${spacing.half};
`;

export const MetricSectionTitle = styled(Overline)`
  color: ${colors.textSecondary};
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
  padding-bottom: ${spacing.half};
`;

export const StyledPrimarySubtitle = styled.span`
 ${subtitle1};
 color: ${colors.textPrimary};
`;

export const StyledSecondarySubtitle = styled.span`
 ${subtitle1};
 color: ${colors.textSecondary};
`;

export const SubtitleContainer = styled.p`
 display: flex;
 gap: ${spacing.quarter};
 margin-bottom: ${spacing.base};
`;

export const ChangeMetricSpacingSubtitleContainer = styled.p`
  & > span:first-child {
    margin-right: ${spacing.quarter};
  }
`;

export const StyledCaption = styled.span`
  ${caption};
  color: ${colors.textSecondary};
  padding-bottom: ${spacing.half};
`;

export const StyledDivider = styled(Divider)`
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
`;

export const PerformanceOverTimeMediumLink = styled.div`
  ${monochromeLink};
  color: ${colors.textSecondary};
`;
